/**
 * Format a duration in hours into a human-readable string
 * @param hours - Duration in hours
 * @returns Formatted duration string (e.g., "2 months", "3 weeks", "5 days", "8 hours", "Just now")
 */
export function formatDuration(hours: number): string {
  if (hours >= 720) {
    const months = Math.floor(hours / 720);
    return `${months} month${months > 1 ? "s" : ""}`;
  }
  if (hours >= 168) {
    const weeks = Math.floor(hours / 168);
    return `${weeks} week${weeks > 1 ? "s" : ""}`;
  }
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    return `${days} day${days > 1 ? "s" : ""}`;
  }
  if (hours >= 1) {
    return `${hours} hour${hours > 1 ? "s" : ""}`;
  }
  return "Just now";
}
